import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next';

interface Review {
    author : {
        name : string
        profile : string
    }
    date : string
    mark : number
    review : String

}

function showMarks(rank:number) {
    let key =1
    let stars = [<li key={key}><i className="fas fa-star"></i></li>];
    --rank
    ++key
    while(rank>=1){
        stars.push(<li key={key}><i className="fas fa-star"></i></li>)
        --rank;
        ++key
    }
    // if(rank>0)
    //     stars.push("fas fa-star-half-o")
    while(stars.length<5){
        stars.push(<li key={key} className="knsl-empty"><i className="fas fa-star"></i></li>)
        ++key
    }
    return(
        <ul className="knsl-stars">
            {stars.map((star,index) => star)}
        </ul>
    )
}

function reviewItem(review:Review, index:number) {
    return(
        <div key={index} id={`review${index+1}`} className="col-lg-12">
            <div className="knsl-review-card knsl-scroll-animation">
                <div className="knsl-card-header">
                    <div className="knsl-name-and-photo">
                        <div className="knsl-avatar-frame">
                            <img src={review.author.profile} alt={review.author.name} />
                        </div>
                        <div>
                            <h5>{review.author.name}</h5>
                            <span>{review.date}</span>
                        </div>
                    </div>
                    {showMarks(review.mark)}
                </div>
                <blockquote> {review.review} </blockquote>
            </div>
         </div>
    )
}


function ReviewBox({onSubmit, end = 'review', idName="messageBox", long=false}) {
    const { t } = useTranslation();
    const inputName = useRef<HTMLInputElement>(null)
    const inputEmail = useRef<HTMLInputElement>(null)
    const inputReview = useRef<HTMLTextAreaElement>(null)

    function submitReview() {
        let name = inputName.current ? inputName.current.value : ''
        let email = inputEmail.current ? inputEmail.current.value : ''
        let review = inputReview.current ? inputReview.current.value : ''

        onSubmit(name, email, review)
    }
    return(
        <section id={idName}>
            <div className="row">
                <div className="col-lg-12">
                <h3 className="knsl-mb-40 knsl-scroll-animation">{long?t(`main.${end}`):t('main.leaveA') + ' ' + t(`main.${end}`)}</h3>
                </div>
                <div className="col-lg-12">
                <form className="knsl-scroll-animation" onSubmit={submitReview}>
                    <div className="row">
                    <div className="col-lg-6">
                        <input type="text" placeholder={t('main.name')} ref={inputName} />
                    </div>
                    <div className="col-lg-6">
                        <input type="email" placeholder={t('main.phoneOrEmail')} ref={inputEmail}  />
                    </div>
                    <div className="col-lg-12">
                        <textarea rows={8} placeholder={t('main.your') + ' ' + t(`main.${end}`) + ' ' + t('main.here')}  ref={inputReview} ></textarea>
                    </div>
                    <div className="col-lg-12">
                        <div className="knsl-form-submit-frame">
                        {/* <!-- temporary button to show the popup --> */}
                        <a className="knsl-btn" data-fancybox href="#knsl-success" onClick={submitReview}>{t('main.send')}</a>
                        <div className="knsl-text-sm">*{t('main.wePromise')}</div>
                        </div>
                    </div>
                    </div>
                </form>
                </div>
            </div>
        </section>
    )
}

export default ReviewBox

export {reviewItem}

export type {Review}